import React, { Component } from 'react'
import { api } from 'app/modules/rules/api'
import { isEmpty, last } from 'lodash'
import { availabilityFilter } from 'app/modules/rules/models'

import RulesEditorOverview from '../../components/RulesEditorOverview/'
import RulesEditor from '../../components/RulesEditor'

import './style.styl'

const actionOnlyFilters = new Set(['onlineUsers'])
const isActionOnlyField = fieldName => actionOnlyFilters.has(fieldName)
const buildRuleFromFilter = (previousRule, newFilters) => {
  const newItem = Object.assign({}, previousRule.data.item, { conditions: [newFilters]})
  return Object.assign({}, previousRule, { data: { item: newItem }})
}


class RulesEditorLayout extends Component {

  constructor(props) {
    super(props)

    const isEditingExistingConditionlessRule = (!!props.activeRule.data.item.id && props.rule.data.item.conditions.length === 0)

    this.state = {
      rule: props.activeRule,
      currentPageValidity: false,
      activeFilter: isEditingExistingConditionlessRule ? 'actionEditor' : 'ADD'
    }
  }

  setPageValidity = canSave => this.setState({ currentPageValidity: canSave })

  componentDidMount() {
    this.props.actions.fetchOrgUsers()
  }

  componentWillMount() {
    const isNew = this.props.params.ruleId === 'new'
    if (!isNew) {
      api.fetchRule(this.props.params.ruleId).then((resp) => {
        this.props.actions.editRule({ item: resp })

        const conditions = resp.conditions[0]
        const isActionOnlyRule = !conditions || conditions.some(({ field }) => isActionOnlyField(field)) || conditions.length === 0
        this.setState({
          activePage: isActionOnlyRule ? 'actionEditor' : 'filterEditor',
          currentPageValidity: true
        })
      })
    }
    else {
      this.setState({
        activePage: 'filterEditor'
      })
    }
  }

  componentWillUnmount() {
    this.props.actions.resetActiveRule()
  }

  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps.activeRule) !== JSON.stringify(this.state.rule)) {
      const { activeFilter } = this.state
      const isNew = !nextProps.activeRule.data.item.createdAt

      const conditions = nextProps.activeRule.data.item.conditions[0]
      const lastFilter = conditions ? last(nextProps.activeRule.data.item.conditions[0]) : availabilityFilter

      const nextActiveFilter = isNew ? activeFilter : lastFilter
      this.setState({ rule: nextProps.activeRule, activeFilter: nextActiveFilter })
    }
  }

  updateTitle = (title) => {
    this.setState((prevState) => {
      const updatedRule = Object.assign({}, prevState.rule.data.item, { name: title })
      const newState = {
        rule: Object.assign({}, prevState.rule, { data: { item: updatedRule }})
      }
      if (this.state.activePage === 'newRuleConfirmation') {
        newState.currentPageValidity = title && title.length
      }
      return newState
    }, () => this.props.actions.editRule(this.state.rule.data))
  }

  setActiveFilter = filter => {
    const isActionOnlyRule = isActionOnlyField(filter.field)
    return this.setState({ activeFilter: filter, activePage: isActionOnlyRule ? 'actionEditor' : 'filterEditor' })
  }

  saveActiveFilter = () => {
    const filter = this.state.activeFilter
    this.setState((prevState) => {
      const normalizedConditions = this.removeFilterBasedOnField(prevState.rule.data.item.conditions[0], filter)
      const conditions = filter === undefined || filter.field === 'onlineUsers' ? [] : [...normalizedConditions, filter]

      return {
        rule: buildRuleFromFilter(prevState.rule, conditions)
      }
    }, () => {
      this.props.actions.editRule(this.state.rule.data)
    })
  }

  removeFilterBasedOnField = (existingFilters, filterToRemove) => {
    if (!existingFilters || !existingFilters.length)
      {return []}

    const filterReference = existingFilters.find(existingFilter => existingFilter.field === filterToRemove.field)
    return _.without(existingFilters, filterReference)
  }

  removeFilter = (filter) => {

    const buildStateChangesAfterRemoval = (newRule) => {
      const conditions = newRule.data.item.conditions[0]
      if (isEmpty(conditions)) {
        return {
          activePage: 'filterEditor',
          activeFilter: 'ADD'
        }
      }

      return {
        activeFilter: conditions[0]
      }
    }

    this.setState(prevState => {
      const previousConditions = prevState.rule.data.item.conditions[0]
      const newConditions = this.removeFilterBasedOnField(previousConditions, filter)
      const newRule = buildRuleFromFilter(prevState.rule, newConditions)
      this.props.actions.editRule({ item: newRule.data.item })

      if (['salesforceOwner', 'targetedAccounts'].includes(filter.field)) {
        this.props.actions.resetActiveRuleAction(newRule)
      }

      return {
        rule: newRule,
        ...buildStateChangesAfterRemoval(newRule)
      }
    })
  }

  updateAction = (action) => {
    const actionPromise = new Promise((resolve) => {
      this.setState((prevState) => {
        const updatedRule = Object.assign({}, prevState.rule.data.item, { action: action })
        return {
          rule: Object.assign({}, prevState.rule, { data: { item: updatedRule }})
        }
      }, () => {
        this.props.actions.editRule(this.state.rule.data)
        resolve()
      })
    })

    return actionPromise
  }

  updateSalesforceLeadRoutingSettings = (settings) => {
    this.setState({ salesforceLeadRoutingSettings: settings })
  }

  updateSalesforceLeadRoutingToggles = (toggles) => {
    this.setState({ salesforceLeadRoutingToggles: toggles })
  }

  setActivePage = (page) => {
    this.setState({ activePage: page })
  }

  getValidityDetails = () => {
    const hasFilter = !!this.state.rule.data.item.conditions[0]
    const filter = hasFilter ? this.state.rule.data.item.conditions[0][0] : {}
    const { action } = this.state.rule.data.item
    const isSalesforce = action.type === 'SALESFORCE_PARTICIPANT'
    const hasAction = !!action.options || isSalesforce

    const hasValidFilter = hasFilter && !!filter.value && (filter.value.length || _.isBoolean(filter.value) || _.isPlainObject(filter.value)) && !!filter.field && !!filter.operator
    const hasValidAction = isSalesforce || (hasAction && action.options.userIds.length && !!action.options.addType)
    const hasValidTitle = this.state.rule.data.item.name.length
    const hasServerError = !!this.state.rule.error

    return { hasValidFilter, hasValidAction, hasValidTitle, hasServerError }
  }

  render() {
    return (
      <div className="rules-editor-container">
        <RulesEditorOverview
          activeFilter={this.state.activeFilter}
          setActiveFilter={this.setActiveFilter}
          saveActiveFilter={this.saveActiveFilter}
          currentPageIsValid={this.state.currentPageValidity}
          updateFilter={this.updateFilter}
          rule={this.state.rule}
          updateTitle={this.updateTitle}
          setActivePage={this.setActivePage}
          users={this.props.users}
          activePage={this.state.activePage}
          removeFilter={this.removeFilter}
          hasABM={this.props.hasABM}
          isActionOnlyField={isActionOnlyField}
        />

        <RulesEditor
          activeFilter={this.state.activeFilter}
          setActiveFilter={this.setActiveFilter}
          currentPageIsValid={this.state.currentPageValidity}
          setPageValidity={this.setPageValidity}
          rule={this.state.rule}
          activePage={this.state.activePage}
          setActivePage={this.setActivePage}
          saveActiveFilter={this.saveActiveFilter}
          updateAction={this.updateAction}
          users={this.props.users}
          updateTitle={this.updateTitle}
          getValidityDetails={this.getValidityDetails}
          showSalesforceOption={this.props.showSalesforceOption}
          updateSalesforceLeadRoutingSettings={this.updateSalesforceLeadRoutingSettings}
          updateSalesforceLeadRoutingToggles={this.updateSalesforceLeadRoutingToggles}
          salesforceLeadRoutingSettings={this.state.salesforceLeadRoutingSettings}
          salesforceLeadRoutingToggles={this.state.salesforceLeadRoutingToggles}
          resetActiveRuleAction = {this.props.actions.resetActiveRuleAction}
          hasABM={this.props.hasABM}
        />
      </div>
    )
  }
}

export default RulesEditorLayout



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/layouts/RulesEditor/index.js